import { Typography } from 'fronton-react';
import React from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { FileUploadDropzoneProps } from '../types';
import { Styles } from './dropzone-caption-inside.styles';
import { DropzoneIcon } from './dropzone-icon';

export const DropzoneCaptionInside: React.FC<FileUploadDropzoneProps> = ({
  inputProps,
  onFilesSelect,
  ...htmlProps
}) => {
  const { t } = useTranslation();
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      onFilesSelect?.(acceptedFiles);
    },
    [onFilesSelect],
  );

  return (
    <div className={Styles.dropzoneCapInsideContent} {...htmlProps}>
      <Dropzone onDrop={onDrop}>
        {({ getInputProps, getRootProps }) => (
          <div
            {...getRootProps({
              className: Styles.dropzoneCapInsideLabel,
              // eslint-disable-next-line i18next/no-literal-string
              'data-anchor': 'dropzone',
            })}
          >
            <DropzoneIcon />
            <Typography className={Styles.dropzoneCapInsideCaption} variant="caption">
              {t('ui.dropzone.click-to-add')}
            </Typography>
            <div className={Styles.inputContainer}>
              <input {...getInputProps(inputProps)} />
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
};
